import { useReduxSelector } from 'hooks';

export default function useGustoHasActiveUserSignedTos() {
  return useReduxSelector((state) => state.gusto.hasSignedTos);
}
